import React,{useState,useEffect, useRef} from "react";
import { useSupabase } from '../context/SupabaseContext';
import { useAuth } from '../context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
var moment = require('moment');

function User() {

  const { profile, updateUserProfile: updateProfileData } = useSupabase();
  const { user } = useAuth();
  const [newName, setNewName] = useState(profile?.name || '');
  const [newEmail, setNewEmail] = useState(profile?.email || user?.email || '');
  const [newAmount, setNewAmount] = useState(profile?.monthly_income?.toString() || '');
  const [newDate, setNewDate] = useState(profile?.salary_date || '');
  const userNameRef = useRef(null);

  const fetchIncome=async()=>{
    // Disabled - using Supabase context instead
    console.log('fetchIncome disabled - using Supabase context');
  }
  const fetchUserProfile=async()=>{
    // Disabled to prevent override of profile updates
    console.log('fetchUserProfile disabled');
    return;
  }
  const handleUpdateProfile=async(name,email)=>{ 
    if (!name || !email) {
      alert('Name and email are required');
      return;
    }
    
    try {
      // Update profile in Supabase
      const result = await updateProfileData({ name, email });
      
      if (result.success) {
        setNewName(name);
        setNewEmail(email);
        alert('Profile updated successfully!');
      } else {
        alert(`Error: ${result.error}`);
      }
    } catch (e) {
      alert(`Error: ${e.message || 'Unknown error'}`);
    }
  }
  
  const postIncome=async(amount,salaryDate)=>{
    if (!amount || !salaryDate) {
      console.error('Amount and salary date are required');
      alert('Amount and salary date are required');
      return;
    }
    try {
      console.log('Submitting income:', { amount, salaryDate });
      
      // Update profile in Supabase with income data
      const result = await updateProfileData({ 
        monthly_income: parseFloat(amount), 
        salary_date: salaryDate 
      });
      
      if (result.success) {
        setNewAmount(amount);
        setNewDate(salaryDate);
        alert('Income updated successfully!');
      } else {
        alert(`Error: ${result.error}`);
      }
    } catch (e) {
      console.error('Error updating income:', e.message);
      alert('Error updating income. Please try again.');
    }
  }
  useEffect(()=>{
    // Disabled - using global state instead
    console.log('useEffect disabled - using global state');
  }, [])

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Edit Profile</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pl-3" md="12">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Form.Control
                          id="exampleInputEmail1"
                          value={newEmail}
                          placeholder="Email"
                          type="email"
                          onChange={(e)=>setNewEmail(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pl-3" md="12">
                      <Form.Group>
                        <label htmlFor="userName">
                          Name
                        </label>
                        <Form.Control
                          id="userName"
                          value={newName}
                          placeholder="Name"
                          onChange={(e)=>setNewName(e.target.value)}
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button
                    className="btn-fill pull-right"
                    variant="info"
                    onClick={()=>handleUpdateProfile(newName,newEmail)}
                  >
                    Update Profile
                  </Button>
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col md="4">
            <Card className="card-user">
                            <Card.Body>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '10px'}}>
                    <i className="fas fa-user-circle" style={{fontSize: '32px', color: '#0B1F3A'}}></i>
                    <span 
  ref={userNameRef}
  id="user-profile-name"
  className="title" 
  style={{
    color: '#000000', 
    fontWeight: 'bold', 
    fontSize: '18px',
    textShadow: 'none',
    backgroundColor: 'transparent',
    opacity: '1',
    visibility: 'visible',
    margin: '0'
  }}
>{profile?.name || user?.email || 'User'}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Income Details</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label htmlFor="totalIncome">TOTAL INCOME</label>
                        <Form.Control
                          id="totalIncome"
                          value={newAmount || profile?.monthly_income?.toString() || ''}
                          onChange={(e)=>setNewAmount(e.target.value)}
                          placeholder="income"
                          type="number"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="6">
                      <Form.Group>
                        <label htmlFor="salaryDate">Date at which you get your salary</label>
                        <Form.Control
                          id="salaryDate"
                          value={newDate || profile?.salary_date || ''}
                          onChange={(e)=>setNewDate(e.target.value)}
                          placeholder="Date"
                          type="date"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button
                    className="btn-fill pull-right"
                    variant="info"
                    onClick={()=>postIncome(newAmount,newDate)}
                  >
                    Update Income
                  </Button>
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default User;
